import { IAnalyticsController } from "./IAnalyticsController";

export class Metrics {
	private static _analytics: IAnalyticsController;
	public static set analytics(value: IAnalyticsController) {
		this._analytics = value;
	}

	public static get analytics(): IAnalyticsController {
		return this._analytics;
	}
}
